import Vue from 'vue'
import VueRouter from 'vue-router';
import { setI18nLanguage } from './in18-setup';

import home from './paginas/home.vue'
import Conteudo from './paginas/conteudo.vue'
import Trechos from './paginas/trechos.vue'
import Planejamento from './paginas/planejamento.vue'
import Ritimo from './paginas/calculoderitmo.vue'
import Altimetria from './paginas/altimetria.vue'
import Tracker from './paginas/tracker.vue'
import Simulation from './paginas/runnerSimulation.vue'
import EquipesInscritas from './paginas/equipesinscritas.vue'




Vue.use(VueRouter)
var languages = ['pt','en'];

// import Store from './store/store'

const routes = [
    { path: '/', component: home,meta:{
        camera: {center:[-47.85927131478161,-15.799714225713075], pitch:55.00000000000001, zoom:12.30769269135277,bearing:0}}},
    { path: '/h', component: home }
]

//IMPORTO TODAS A DIRECTIVES AUTOMATICAMENTE DA PASTA DIRECTIVES
function requireAll(requireContext) {
    var keys = requireContext.keys()
    _.forEach(keys, k => {
        var modulo = requireContext(k)
        var nome = k.match(/([^/]*).vue$/)
        // routes.push({ path: "/"+nome[1], component: modulo })
        routes.push({ path: "/"+nome[1]+"/:id?", component: modulo })
    })
};requireAll(require.context("./paginas", true, /^\.\/.*\.vue$/));



//fall back to conteudo page wha i never speifies
routes.push( { path: "/pagina/:id?", component: Conteudo,  
            meta: { 
                contentClass: "col-12 col-sm-6 col-md-4 col-lg-4", 
                contentWidth: 400,
                camera:{
                    regulamento:{center:[-47.85963514449361,-15.779336201891468], pitch:39.500000000000036, zoom:14.775265027262096,bearing:-78.39179928857232},
                    'kit-do-atleta':{center:[-47.8554108316921,-15.805223127031667], pitch:55.00000000000001, zoom:13.637446149968344,bearing:0},
                    'contato':{center:[-47.900464306510685,-15.73902774924808], pitch:58.99999999999999, zoom:17.82654106006601,bearing:-78.44444444456877},
                },
                url:{
                    regulamento:'paginas/regulamento',
                    'kit-do-atleta':'paginas/kit-do-atleta',
                    'contato':'/contato',
                }
            }
})


//fall back to conteudo page wha i never speifies
routes.push( { path: "/prova/:id?", component: Conteudo,  
            meta: { 
                contentClass: "col-12 col-sm-6 col-md-4 col-lg-4", 
                contentWidth: 400,
                camera:{
                    regras:{center:[-47.88415363009665,-15.80309321214898], pitch:60, zoom:17.19463353922793,bearing:-24.000000000001133},
                    regulamento:{center:[-47.85963514449361,-15.779336201891468], pitch:39.500000000000036, zoom:14.775265027262096,bearing:-78.39179928857232},
                    'kit-do-atleta':{center:[-47.8554108316921,-15.805223127031667], pitch:55.00000000000001, zoom:13.637446149968344,bearing:0},
                    'valores':{center:[-47.87496275656258,-15.830060489030686], pitch:10.500000000000023, zoom:14.847388297647138,bearing:40.79999999999995}
                },

                url:{
                    regras:'/paginas/regras',
                    regulamento:'/paginas/regulamento',
                    'kit-do-atleta':'/paginas/kit-do-atleta',
                }
            }
} )




//fall back to conteudo page wha i never speifies
routes.push( { path: "/percurso/altimetria", component: Altimetria,  
            meta: { 
                camera:{center:[-47.876230601597285,-15.815709312656253], pitch:60, zoom:12.497745586856384,bearing:15.75689881746689}
            }
} )


//fall back to conteudo page wha i never speifies
routes.push( { path: "/altimetria", component: Altimetria,  
            meta: { 
              outracoisa:"uma metaaaa"
            }
} )


//fall back to conteudo page wha i never speifies
routes.push( { path: "/simulation/:id?", component: Simulation,  
            meta: { 
              outracoisa:"uma metaaaa"
            }
} )



//fall back to conteudo page wha i never speifies
routes.push( { path: "/percurso/calculo-de-ritmo/:id?", component: Ritimo,  
            meta: { 
                contentClass: "col-10 col-sm-4 col-md-4 col-lg-4", 
                contentWidth: 400,
                camera:{
                    'calculo-de-ritmo':{center:[-47.880458506715286,-15.801118965232092], pitch:60, zoom:16.418923313739327,bearing:28}
                }
            }
} )

//fall back to conteudo page wha i never speifies
routes.push( { path: "/percurso/trechos/:id?/:race?", component: Trechos,  
            meta: { 
                contentClass: "col-10 col-sm-4 col-md-4 col-lg-4", 
                contentWidth: 400,
                name:"trecho",
                camera:false,//{center:[-47.880458506715286,-15.801118965232092], pitch:60, zoom:16.418923313739327,bearing:28}
          
            }
} )


//fall back to conteudo page wha i never speifies
routes.push( { path: "/percurso/planejamento/:id?/:race?", component: Planejamento,  
            meta: { 
                contentClass: "col-10 col-sm-4 col-md-4 col-lg-4", 
                contentWidth: 400,
                name:"planejamento",
                camera:false,//{center:[-47.880458506715286,-15.801118965232092], pitch:60, zoom:16.418923313739327,bearing:28}
          
            }
} )

//fall back to conteudo page wha i never speifies
routes.push( { path: "/equipes/inscritas", component: EquipesInscritas,  
            meta: { 
                contentClass: "col-10 col-sm-6 col-md-6 col-lg-4", 
                contentWidth: 400,
                name:"equipesinscritas",
                camera:false,//{center:[-47.880458506715286,-15.801118965232092], pitch:60, zoom:16.418923313739327,bearing:28}
          
            }
} )







//loop cada router e aplico tb a opcao de cada language
// exemplo   /home = /en/home   e /pt/home
var routesFinal = [...routes]

_.each(routes, route=>{
    _.each(languages,lang=>{
           var newRoute = {...route};
           newRoute.path = "/:lang?"+newRoute.path  
           routesFinal.push(newRoute);
    })

})


// console.log("+++++++++++++++ ROUTES +++++++++++++++++++")
// console.log(routesFinal)


// 3. Create the router instance and pass the `routes` option
// You can pass in additional options here, but let's
// keep it simple for now.
const router = new VueRouter({
    routes:routesFinal // short for `routes: routes`
})


router.beforeEach((to, from, next) => {
  if(to.params.lang){
    const lang = to.params.lang
    // setI18nLanguage(lang)
    window.$store.dispatch('setCurrentLang',lang);
  }

      
     if(window.store.state.currengLang){
            var lang = window.store.state.currengLang;
            if(to.path.indexOf(lang) == 1){
                next();
            }else{
                next({path:'/'+lang+to.path,replace:true});
            }
    }

  next();
})


export default router;